"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _analyticsInterface = require("@telus/analytics-interface");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _index = require("../../constants/index.js");
var _index2 = require("../../utils/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PAGE_LOADED = _index.eventTypes.PAGE_LOADED;
var appendWebPageDetails = function appendWebPageDetails(event) {
  var eventType = (0, _get2["default"])(event, 'event');
  if (eventType === PAGE_LOADED) return event;
  var persisted = (0, _analyticsInterface.pageDetails)().get();
  if (!persisted) return event;
  var current = (0, _get2["default"])(event, 'xdm.web.webPageDetails');
  var webPageDetails = current ? (0, _index2.mergeObjects)(current, persisted) : persisted;
  if (current) (0, _analyticsInterface.pageDetails)().set((0, _index2.removeEmptyKeys)(webPageDetails));
  (0, _set2["default"])(event, 'xdm.web.webPageDetails', webPageDetails);
  return event;
};
var _default = exports["default"] = appendWebPageDetails;